import { AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { dataUri, RxwebValidators } from '@rxweb/reactive-form-validators';
import { ReCaptcha2Component } from 'ngx-captcha';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/app/services/api.service';
import { EncryptionService } from 'src/app/services/encryption.service';
import { CommonEnums } from 'src/app/utils/enum-utils';
import { Otp } from 'src/app/utils/request-dto';
declare let $: any;


@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
})
export class SignupComponent implements OnInit {
  @Output() isLogin = new EventEmitter<boolean>();
  @ViewChild('ngOtpInput') ngOtpInputRef: any;
  @ViewChild('productKey') productKey: any
  @ViewChild('captchaElem') captchaElem: ReCaptcha2Component;
  isSentOTP: boolean = false;
  isProducyKeyVerified: boolean = false;
  emailVerified: boolean = false;
  isSubmitted = false;
  emailResponse: any;
  otpValue: string = '';
  pwdNotMatch: boolean = false;
  password: any;
  newPassword: boolean = false;
  confPassword: boolean = false;
  productKeyLoader: boolean = false;
  getSignupUrl: any;
  getSignupUrlFaceook: any;
  submitOTPDto: Otp = new Otp();
  timer: any;
  passwords: any = CommonEnums.password;
  errorForVerification: boolean = false;
  getErrorMessageForEmailVerification: any;
  emailErrorMessage: any
  siteKey: string = '6LcMjEwhAAAAAE2vVJmSbwo8S4lqZithppOd-qlO';
  signuoGoogleCode: string = '';
  durationMinutes: any;
  timeOver: boolean = true;
  isLoading: boolean = false;
  isInvalidEmail: boolean = false;
  invalidEmailStatMsg: String = '';
  signUpForm: FormGroup = new FormGroup({
    name: new FormControl(''),
    email: new FormControl(''),
    mobileNo: new FormControl(''),
    password: new FormControl(''),
    confirmPassword: new FormControl(''),
    acceptTerms: new FormControl(''),
  });
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  @ViewChild("testInput") testInput: any;

  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  constructor(
    private _formBuilder: FormBuilder,
    private _service: ApiService,
    private _toastr: ToastrService,
    private _actRoute: ActivatedRoute,
    private encrypt: EncryptionService
  ) { }

  showCaptcha: boolean = false;

  social: any
  ngOnInit(): void {

    scrollTo(0, 0)
    this.password = CommonEnums.password;
    this.signUpForm = this._formBuilder.group(
      {
        name: ['', [Validators.required]],
        email: ['', [Validators.required, Validators.email, Validators.pattern('^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([A-Za-z]{2,6}(?:\\.[A-Za-z]{2,6})?)$')]],
        mobileNo: [''],
        password: ['', [RxwebValidators.password({
          validation: {
            upperCase: true,
            lowerCase: true,
            specialCharacter: true
          }
        }), RxwebValidators.minLength({ value: 8 }),
          // RxwebValidators.maxLength({ value: 30 })
        ]],
        confirmPassword: ['', Validators.required],
        acceptTerms: [false, Validators.requiredTrue],
        captchaToken: ['']
      },
    );
    this.signuoGoogleCode = this._actRoute.snapshot.queryParams["code"];
    let social = localStorage.getItem('socialData');
    if (social) {
      this.social = JSON.parse(social);
      this.getSignupUrl = this.social.googleUrlSignUp;
      this.getSignupUrlFaceook = this.social.facebookUrlSignUp;
    }
  }
  count: number = 0;
  changePreferredCountries() {
    this.preferredCountries = [CountryISO.India, CountryISO.Canada];
  }

  get f(): { [key: string]: AbstractControl } {
    return this.signUpForm.controls;
  }


  clearfield(e: any) {
    if (e.key == 'Backspace') {
      this.emailVerified = false;
      this.isSentOTP = false;
      this.emailErrorMessage = null;
      this.invalidEmailStatMsg = '';
    }

  }

  //  Sending Data to Backend For Signup Check and Redirecting on Dashboard 
  onSignUp(event: MouseEvent) {
    console.log(this.signUpForm?.controls['mobileNo']?.value);

    try {
      let data = {
        name: this.signUpForm.controls['name'].value,
        email: this.signUpForm.controls['email'].value,
        countryCode: this.signUpForm?.controls['mobileNo']?.value?.dialCode,
        mobileNo: this.signUpForm?.controls['mobileNo']?.value?.number,
        password: this.encrypt.encrypt(this.signUpForm.controls['password'].value),
        confirmPassword: this.encrypt.encrypt(this.signUpForm.controls['confirmPassword'].value),
        acceptTerms: this.signUpForm.controls['acceptTerms'].value,
        captchaToken: this.signUpForm?.controls['captchaToken']?.value,

      };
      (event.target as HTMLButtonElement).disabled = true;
      this._service
        .postService(this._service.API_URL.signup, data)
        .subscribe((response: any) => {
          if (response.status.code === 200) {
            this.signUpForm.reset();
            this.isProducyKeyVerified = false;
            this.emailVerified = false;
            $("#signupSuccess").modal("show")
          } else {
            this._toastr.error('', response.status.message);
            (event.target as HTMLButtonElement).disabled = false;
          }

          // })
        });
    } catch (e) { }
  }



  //  When Clicking on Already Have an account ? Login Sending to Login page

  goToLogin(value: boolean) {
    this.isLogin.emit(value);
    $('#signupSuccess').modal("hide");
  }

  // Checking (Matching)  Password and Confirm Password Validation 
  onClick(val: string) {
    if (val == 'pwd') {
      if (this.password === 'password') {
        this.password = CommonEnums.text;
        this.newPassword = true;
      } else {
        this.password = CommonEnums.password;
        this.newPassword = false;
      }
    } else if (val == 'confPwd') {
      if (this.passwords === 'password') {
        this.passwords = CommonEnums.text;
        this.confPassword = true;
      } else {
        this.passwords = CommonEnums.password;
        this.confPassword = false;
      }
    }
  }

  verifyEmailwithActivation() {
    let data = {
      userName: this.signUpForm.controls['email'].value,
    };
    if (this.signUpForm.controls['email'].valid) {
      this._service.postService(this._service.API_URL.verifyEmailwithActivation, data).subscribe((response: any) => {
        if (response && response.status.code === 200) {
          if (response.status.msgCode === 'EMAIL_DOESNT_EXIST_WITH_ANY_PRODUCT_KEY') {
            this.isInvalidEmail = true;
            this.invalidEmailStatMsg = response?.status?.message;
          }
          else {
            this.isInvalidEmail = false;
          }
        } else if (response && response.status.code === 400) {
          this.isInvalidEmail = true;
          this.invalidEmailStatMsg = response?.status?.message;
        }
        if (response.status.msgCode === 'EMAIL_DOESNT_EXIST_WITH_ANY_PRODUCT_KEY' || response.status.msgCode === 'USER_EXIST_WITH_EMAIL') {
          this.isInvalidEmail = true;
          this.invalidEmailStatMsg = response?.status?.message;
        }
      });
    }
  }


  // To get OTP for Email Verification
  emailOTP() {
    try {
      this.isLoading = true;
      this.emailErrorMessage = null;
      clearInterval(this.timer);
      // this.isSentOTP = false;
      this.timeOver = true;
      let data = {
        userName: this.signUpForm.controls['email'].value,
        otpType: CommonEnums.SIGNUP,
        langPref: localStorage.getItem('SocialSelectedLang') || 'ENGLISH',
      };
      this._service
        .postService(this._service.API_URL.emailGenerateOtp, data)
        .subscribe((response: any) => {
          if (response.status.code === 200) {
            this.isSentOTP = true;
            this.isLoading = false;
            this.startTimerForFiveMinute(3);
            this.emailResponse = response.data;
            setTimeout(() => {
              this.ngOtpInputRef.setValue(null);
            }, 0);
          } else {
            this.emailErrorMessage = response.status.message
            this.isSentOTP = false;
            this.isLoading = false;
          }
        });
    } catch (e) {
      this.isLoading = false;
    }
  }


  onOtpChange(event: any) {
    this.emailErrorMessage = null;
    this.otpValue = event;
  }

  // Clearing Email to ReEnter the email here
  clearEmail() {
    this.signUpForm.controls['email'].setValue('');
    this.signUpForm.controls['email'].enable();
    this.emailVerified = false;
  }



  // To get OTP for Email Verification  Resend OTP Logic is here
  submitOTP() {
    try {
      if (this.otpValue?.length == 4) {
        this.submitOTPDto.otpChar = this.emailResponse;
        this.submitOTPDto.otpType = CommonEnums.SIGNUP;
        this.submitOTPDto.otpNo = this.otpValue
        this._service
          .postService(this._service.API_URL.signupOtpVerification, this.submitOTPDto)
          .subscribe((response) => {
            if (response.status.code === 200) {
              this.isSentOTP = false;
              this.emailVerified = response.data.isOtpVerification;
              this.signUpForm.controls['email'].disable();
              this.emailErrorMessage = null;
              this.timeOver = true;
              clearInterval(this.timer);
            } else {
              this.emailErrorMessage = response.status.message;
              this.signUpForm.controls['email'].enable();
            }
          });
        // let otpResponse = this._commonService.verifyOTP(data);
      }
    } catch (e) { }
  }


  // Checking on Mobie validation on Focus Out and Verifying
  productkeyWrong: boolean = false;
  onFocusOutProductKey() {
    this.errorForVerification = false;
    if (this.signUpForm.controls['productKey'].value?.length != 23) {
      this.productkeyWrong = true;
    } else {
      this.productkeyWrong = false;
    }
  }
  // Checking on Mobie validation on Focus Out and Verifying
  mobileNoWrong: boolean = false;
  onFocusOutMobile(event: any) {
    // console.log(event, "focus");
    if (event?.number?.length < 8) {
      this.mobileNoWrong = true;
    } else {
      this.mobileNoWrong = false;
    }
  }

  // Checking on Password on Focus Out and Verifying
  onFocusOut() {
    if (
      this.signUpForm.controls['password'].value !==
      this.signUpForm.controls['confirmPassword'].value
    ) {
      this.pwdNotMatch = true;
    } else {
      this.pwdNotMatch = false;
    }
  }

  passwordVerify() {
    if (this.signUpForm.controls['confirmPassword'].value?.length != 0 && this.signUpForm.controls['password'].value !==
      this.signUpForm.controls['confirmPassword'].value) {
      this.pwdNotMatch = true;
    } else {
      this.pwdNotMatch = false;
    }
  }


  // Clicking on Google to Signup with the same 
  signUpWIthGoogle() {
      window.location.href = this.getSignupUrl;
  }
  // Clicking on Facebook to Signup with the same 
  signUpWIthFacebook() {
    try {
      window.location.href = this.getSignupUrlFaceook;
    } catch (error) {
      //console.log(error);

    }
  }


  //  Fetching Social Media Link is here to link to Google and Facebook
  getSocialUrl() {
    this._service.getService(this._service.API_URL.getSocialUrl).subscribe((response) => {
      if (response && response.status.code === 200) {
        this.getSignupUrl = response.data.googleUrlSignUp;
        this.getSignupUrlFaceook = response.data.facebookUrlSignUp;
      }
    })
  }

  //  Start timer for Email Verification
  startTimerForFiveMinute(minute: number) {
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;
    const prefix = minute < 10 ? "0" : "";
    this.timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.durationMinutes = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
      if (seconds == 0) {
        this.timeOver = false;
        clearInterval(this.timer);
      }
    }, 1000);
  }

  isPaste: boolean = false;
  pasteEvent(eve: any): void {
    this.isPaste = true;
    this.verifyProductKeyFromAddDevice(eve);
  }

  keyPressAlphaNumericWithCharacters(event: any, name: any) {
    if (name == 'email') {
      if (event.target.selectionStart === 0) {
        let k;
        k = event.charCode;  //         k = event.keyCode;  (Both can be used)
        return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
      }

    } else if (name == 'key' || name == 'mobile') {

      let k;
      k = event.charCode;  //         k = event.keyCode;  (Both can be used)
      return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57))
    } else if (name == 'name') {
      if (event.target.selectionStart === 0) {
        let k;
        k = event.charCode;  //         k = event.keyCode;  (Both can be used)
        return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57))
      }
    } else {
      let inp = String.fromCharCode(event.keyCode);
      // Allow numbers, alpahbets, space, underscore
      if (/[a-zA-Z0-9-_ ]/.test(inp)) {
        return true;
      } else {
        event.preventDefault();
        return false;
      }
    }


  }
  counts: number = 0;
  checkCallOnce: boolean = false;
  errorMessage: string = '';
  verifyProductKeyFromAddDevice(event: any) {
    let data = {
      productKey: this.signUpForm.controls['productKey'].value.split('-').join(''),
      isSignUp: true
    }
    let selectionStart = event.target.selectionStart, key = event.key;
    if (key != 'Backspace' && key != 'Control' && key != 'Delete' && key != 'Enter' && key != 'Space' && !this.checkCallOnce && key != 'ArrowRight' && key != 'ArrowLeft' && key != 'ArrowUp' && key != 'ArrowDown') {
      // console.log(key);

      switch (selectionStart) {
        case 6:
          event.target.setSelectionRange(7, 7);
          break;
        case 12:
          event.target.setSelectionRange(13, 13);
          break;
        case 18:
          event.target.setSelectionRange(19, 19);
          break;
        case 21:
          event.target.setSelectionRange(21, 21);
          break;
        case 22:
          event.target.setSelectionRange(22, 22);
          break;
      }

      try {
        if (data.productKey?.length == 20) {
          // if (selectionStart == 20) {
          event.target.setSelectionRange(23, 23);
          // }
          this.productKeyLoader = true
          this.checkCallOnce = true;
          this._service.postService(this._service.API_URL.verifyProductKey, data).subscribe((response: any) => {
            if (response && response.status.code === 200) {
              //console.log(this.checkCallOnce);
              this.productKeyLoader = false;
              this.errorMessage = '';
              // this.disableAdd = false
              this.productkeyWrong = false;
              this.isProducyKeyVerified = true;
              this.errorForVerification = false;
              // if (response.data.packInfo) {
              //   // setTimeout(() => {
              //   //   // this.disablebtn = true;
              //   // }, 0);
              // }
              // this.packInfo = response.data.packInfo;
              // this.otpErrorMessage = null;
              if (this.counts >= 3) {
                this.showCaptcha = true;
                this.signUpForm.controls['captchaToken'].addValidators(Validators.required);
              }
              else {
                this.showCaptcha = false
              }

            } else if (response && response.status.code === 400) {
              this.productKeyLoader = false;
              this.productkeyWrong = true
              this.errorMessage = response?.status?.message;

              this.errorForVerification = true;
              this.isProducyKeyVerified = false;
              if (this.signUpForm.controls['captchaToken'].value) {
                this.captchaElem.reloadCaptcha();
                this.signUpForm.controls['captchaToken'].setValue(null)
                this.isProducyKeyVerified = false;
                this.signUpForm.controls['captchaToken'].addValidators(Validators.required);
              }
              this.counts++;
              if (this.counts >= 3) {
                this.showCaptcha = true;
                this.signUpForm.controls['captchaToken'].addValidators(Validators.required);
              }
              else {
                this.productkeyWrong = true;
                this.showCaptcha = false;
                this.errorMessage = response?.status?.message;

              }
              //console.log(this.checkCallOnce);

            }
            else
              if (response.status.msgCode === 'QH_INVALID_PRODUCT_KEY') {
                this.errorForVerification = true;
                this.productkeyWrong = true;
                this.errorMessage = response?.status?.message;
                //console.log(this.checkCallOnce);

              }
          })
        } else {
          this.checkCallOnce = false;
          //console.log(this.checkCallOnce);

        }
      }
      catch (e) { this.checkCallOnce = false; }
    } else if (event.key == 'Backspace' || event.key == 'Delete') {
      if (data.productKey?.length != 20 && data.productKey?.length != 0) {
        this.errorMessage = ''
        this.checkCallOnce = false;
        this.isProducyKeyVerified = false;
        // this.productKeyLoader = true;
        this.productkeyWrong = true;
      } else if (data.productKey?.length == 0) {
        this.productKeyLoader = false;
        this.errorMessage = ''
        this.isProducyKeyVerified = false;
        this.productkeyWrong = false;
        this.checkCallOnce = false;
      } else {
        this.errorForVerification = true;
      }
      //console.log(this.checkCallOnce);

    } else {
      // console.log(data.productKey?.length);

    }
    //console.log(this.checkCallOnce);

  }
  removeSpace(event: any, name: any) {

    if (name == 'key' || name == 'email') {
      if (event.code === "Space") {
        // console.log('space removed');
        event.preventDefault()

      }
    } else if (name == 'mobile' || name == 'pass') {
      if (event.code === "Space") {
        event.preventDefault()

      }

    }
    else {
      if (event.target.selectionStart === 0 && event.code === "Space") {
        event.preventDefault()

      }
    }

  }


  onlyAlphabets(event: any) {
    if (event.target.selectionStart === 0) {
      if ((/\d/g).test(event.key)) event.preventDefault();
    }
  }

  // openLoader(val: any) {
  //   if (val?.length == 23)
  //     this.productKeyLoader = true;
  //   else this.productKeyLoader = false;
  // }
}
